import { DeviceProvider } from './device';
import { Platform } from '@ionic/angular';
import { AndroidSettings, IOSSettings } from 'capacitor-native-settings';

/**
 * Browser device provider
 */
export class DeviceBrowserProvider extends DeviceProvider
{
    //#region Constructor

    /**
     * Class constructor
     * @param platform 
     * @param camera 
     */
    constructor(
        platform: Platform)
    {
        super(platform);
    }

    //#endregion

    //#region Methods - Device Actions

    /**
     * Browser implementation for calling a number
     * @param number
     */
    public callNumber(number: string)
    {
        window.open(`tel:${number.replace(' ', '')}`)
    }

    /**
     * Open the device's settings
     * @param settings 
     */
    public openSettings(settings: AndroidSettings | IOSSettings)
    {
        throw new Error('Method not supported for browser.');
    }

    /**
     * Load a file from the device
     * @param fileName file name
     */
    public loadFile(fileName: string): Promise<File>
    {
        throw new Error('Method not supported for browser.');
    }

    /**
     * Save a file on the browser
     * @param fileName file name
     * @param blob file blob
     */
    public saveFile(fileName: string, blob: Blob): Promise<any>
    {
        // Create the blob url object
        let blobUrl: string = window.URL.createObjectURL(blob);

        // Create an object Url out of the blob and use it to download the file
        // without need of any unncessary plugins.
        let aTag = document.createElement('a');
        aTag.download = fileName;
        aTag.href = blobUrl;
        aTag.click();

        // Perform the necessary cleanup
        aTag.remove();
        window.URL.revokeObjectURL(blobUrl);

        // Resolve the promise
        return Promise.resolve();
    }

    //#endregion
}
